import { useQuery, useMutation } from "@tanstack/react-query";
import api from "@services/api";

async function fetchReports() {
  const { data } = await api.get("/reports");
  return data;
}

export function useReportsQuery() {
  return useQuery({
    queryKey: ["reports", "definitions"],
    queryFn: fetchReports
  });
}

export function useRunReportMutation() {
  return useMutation({
    mutationFn: async ({ key, params }) => {
      const { data } = await api.post(`/reports/${key}/run`, params);
      return data;
    }
  });
}

